import { dataLayerPush } from "./data-layer-push";

interface Params {
  page: number;
  params: {
    searchQuery: string | null;
    filter: string;
    geosearchPlaceName?: string;
    geosearchPlaceId?: string;
    postingDateFilter?: string;
  };
}

let FILTER_CACHE: Params = {
  params: {
    searchQuery: "",
    filter: "",
    geosearchPlaceName: undefined,
    geosearchPlaceId: undefined,
    postingDateFilter: undefined,
  },
  page: 0,
};

export function trackingOnFilterSearch(args: Params): void {
  if (JSON.stringify(args) !== JSON.stringify(FILTER_CACHE)) {
    const {
      page,
      params: {
        filter,
        searchQuery,
        geosearchPlaceId,
        geosearchPlaceName,
        postingDateFilter,
      },
    } = args;
    dataLayerPush({
      event:
        page === 0
          ? "jobboard_filtersearch"
          : "jobboard_filtersearch_load_more",
      searchQuery: searchQuery ?? "",
      filterValues: filter,
      geosearchPlaceName,
      geosearchPlaceId,
      postingDateFilter,
      jobboardLoadMorePage: String(page + 1),
    });

    FILTER_CACHE = args;
  }
}
